import { render, staticRenderFns } from "./AAsignacionTablaCor.vue?vue&type=template&id=1ac032bf"
import script from "./AAsignacionTablaCor.vue?vue&type=script&lang=js"
export * from "./AAsignacionTablaCor.vue?vue&type=script&lang=js"
import style0 from "./AAsignacionTablaCor.vue?vue&type=style&index=0&id=1ac032bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports